/* eslint-disable no-console */
import { initReactSentry, reportToSentry } from '@bharatpe/bp-errorlog';
import { isProd } from './Utils';
import pkjson from '../../package.json';

const sentryDSN = 'https://08a01dce310d484ca20addb20ff1ae81@sentry-website.bharatpe.in/22';

const APP_NAME = `${pkjson.name}@${pkjson.version}`;

export const initSentry = (): void => {
	try {
		if (isProd()) {
			initReactSentry({
				dsn: sentryDSN,
				tracesSampleRate: 0.2,
				release: APP_NAME,
			});
		}
	} catch (e) {
		// eslint-disable-next-line no-undef
		console.error('SentryIntegrationError: ', e);
	}
};

/**
 * @function sendEvent
 * @param {object|string} event
 * @description manually send event/exception to Sentry
 */
export const sendEvent = (event: string | Error): void => {
	reportToSentry(event);
};
